import { useState, useEffect, useContext, useRef, CSSProperties } from 'react'
import { useLocation } from 'react-router-dom'
import DataTable from '../components/DataTable';
import { KTSVG } from '../../_metronic/helpers'
import 'react-loading-skeleton/dist/skeleton.css';
import ShipmentCreate from '../components/ShipmentCreate';
import ShipmentDetails from '../components/ShipmentDetails';
import { getRequestOptions } from '../helpers/Fetchwrapper';
import Select from 'react-select';
import { AppContext } from '../context/AppContext';

function ShipmentRowActions({ row, onDetails }: { row: any; onDetails: (shipment: any) => void }) {
    const [open, setOpen] = useState(false)
    const [menuStyle, setMenuStyle] = useState<CSSProperties>({ display: 'none' })
    const containerRef = useRef<HTMLDivElement>(null)
    const buttonRef = useRef<HTMLButtonElement>(null)

    const updateMenuPosition = () => {
        if (!buttonRef.current) {
            return
        }

        const rect = buttonRef.current.getBoundingClientRect()
        setMenuStyle({
            position: 'fixed',
            top: `${rect.bottom + 2}px`,
            left: `${rect.right}px`,
            transform: 'translateX(-100%)',
            minWidth: 'max-content',
            width: 'auto',
            whiteSpace: 'nowrap',
            zIndex: 1050,
            display: 'block',
        })
    }

    useEffect(() => {
        if (!open) {
            setMenuStyle({ display: 'none' })
            return
        }

        updateMenuPosition()

        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                setOpen(false)
            }
        }

        const handleReposition = () => setOpen(false)

        document.addEventListener('mousedown', handleClickOutside)
        window.addEventListener('scroll', handleReposition, true)
        window.addEventListener('resize', handleReposition)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            window.removeEventListener('scroll', handleReposition, true)
            window.removeEventListener('resize', handleReposition)
        }
    }, [open])

    const closeMenu = () => setOpen(false)

    const openDownload = (url: string) => {
        closeMenu()
        window.open(url, '_blank')
    }

    return (
        <div ref={containerRef} className="d-flex justify-content-center">
            <button
                ref={buttonRef}
                className="btn btn-light-primary btn-sm dropdown-toggle"
                type="button"
                aria-expanded={open}
                onClick={(e) => {
                    e.stopPropagation()
                    setOpen((prev) => !prev)
                }}
            >
                Action
            </button>
            <div className="dropdown-menu dropdown-menu-end show" style={menuStyle}>
                <button
                    type="button"
                    className="dropdown-item d-flex align-items-center text-nowrap"
                    onClick={() => {
                        closeMenu()
                        onDetails(row)
                    }}
                >
                    <KTSVG
                        path='/media/svg/icons/Layout/Layout-grid.svg'
                        className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                    />
                    Details
                </button>
                <button
                    type="button"
                    className="dropdown-item d-flex align-items-center text-nowrap"
                    onClick={() => openDownload(`${process.env.REACT_APP_BACKEND}shipment/download/${row.id}?free_item=1`)}
                >
                    <KTSVG
                        path='/media/svg/icons/Devices/Printer.svg'
                        className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                    />
                    Chalan
                </button>
                <button
                    type="button"
                    className="dropdown-item d-flex align-items-center text-nowrap"
                    onClick={() => openDownload(`${process.env.REACT_APP_BACKEND}shipment/view/${row.id}?free_item=1`)}
                >
                    <KTSVG
                        path='/media/svg/icons/General/Visible.svg'
                        className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                    />
                    Chalan View
                </button>
                {row.doublePrint === 'Yes' && (
                    <button
                        type="button"
                        className="dropdown-item d-flex align-items-center text-nowrap"
                        onClick={() => openDownload(`${process.env.REACT_APP_BACKEND}shipment/download/${row.id}?free_item=1&withoutBackground=1`)}
                    >
                        <KTSVG
                            path='/media/svg/icons/Devices/Printer.svg'
                            className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                        />
                        Chalan without Background
                    </button>
                )}
                <button
                    type="button"
                    className="dropdown-item d-flex align-items-center text-nowrap"
                    onClick={() => openDownload(`${process.env.REACT_APP_BACKEND}shipment/download/${row.id}?free_item=0`)}
                >
                    <KTSVG
                        path='/media/svg/icons/Devices/Printer.svg'
                        className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                    />
                    Chalan Without Free Items
                </button>
                {row.doublePrint === 'Yes' && (
                    <button
                        type="button"
                        className="dropdown-item d-flex align-items-center text-nowrap"
                        onClick={() => openDownload(`${process.env.REACT_APP_BACKEND}shipment/download/${row.id}?free_item=0&withoutBackground=1`)}
                    >
                        <KTSVG
                            path='/media/svg/icons/Devices/Printer.svg'
                            className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                        />
                        Chalan Without Free Items without Background
                    </button>
                )}
                {Number(row.idProjects) === 3 && (
                    <button
                        type="button"
                        className="dropdown-item d-flex align-items-center text-nowrap"
                        onClick={() => openDownload(`${process.env.REACT_APP_BACKEND}shipment/weight-slip/${row.id}?free_item=1`)}
                    >
                        <KTSVG
                            path='/media/svg/icons/Devices/Printer.svg'
                            className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                        />
                        Weight Slip
                    </button>
                )}
                {Number(row.idProjects) === 3 && row.doublePrint === 'Yes' && (
                    <button
                        type="button"
                        className="dropdown-item d-flex align-items-center text-nowrap"
                        onClick={() => openDownload(`${process.env.REACT_APP_BACKEND}shipment/weight-slip/${row.id}?free_item=1&withoutBackground=1`)}
                    >
                        <KTSVG
                            path='/media/svg/icons/Devices/Printer.svg'
                            className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                        />
                        Weight Slip without Background
                    </button>
                )}
            </div>
        </div>
    )
}

function Shipment() {

    const location = useLocation();
    const { currentUser } = useContext(AppContext);
    const [selectProjectOptions, setSelectProjectOptions] = useState([])
    const [project, setProject] = useState({ label: 'Select Project', value: '' });

    const handleProjectChange = (project: any) => {
        setProject(project);
    }

    useEffect(() => {
        getProjectList();
    }, [])

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const openShipmentId = params.get('shipmentId');
        if (openShipmentId) {
            setShipmentId(openShipmentId);
            setDetailsShipmentModalShow(true);
        }
    }, [location.search])

    const getProjectList = async () => {
        const url = process.env.REACT_APP_API_URL + 'projects';

        const response = await fetch(url, getRequestOptions());

        const data = await response.json();

        data.data.map((element: any) => {
            element.value = element.id_projects;
            element.label = element.project_name;
            return element;
        })

        if (data.data.length === 1) {
            setSelectProjectOptions(data.data)
        } else {
            var allProjectsOpt = [{ id: '', name: '', label: 'All Project', value: '' }]
            let allProjects = data.data.concat(allProjectsOpt);
            setSelectProjectOptions(allProjects);
        }
    }

    useEffect(() => {
        if (selectProjectOptions.length === 1) {
            setProject({ label: selectProjectOptions[0]['label'], value: selectProjectOptions[0]['value'] })
        }
    }, [selectProjectOptions])

    useEffect(() => {
        setAdditionalPostData({ idProjects: project.value })
    }, [project])

    const [additionalPostData, setAdditionalPostData] = useState({ idProjects: '' });
    const [createShipmentModalShow, setCreateShipmentModalShow] = useState(false);
    const [detailsShipmentModalShow, setDetailsShipmentModalShow] = useState(false);
    const [salesOrderInfo, setSalesOrderInfo] = useState({});
    const [shipmentId, setShipmentId] = useState('');
    const [newData, setNewData] = useState({});

    const handleCreateShipmentModalClose = (isReload: boolean) => {
        setCreateShipmentModalShow(false);
        if (isReload) {
            setNewData({ id: Date.now() });
        }
    }

    const handleDetailsShipmentModalClose = (isReload: boolean) => {
        setDetailsShipmentModalShow(false);
    }

    const handleShipmentModalShow = (salesOrderInfo: any) => {
        setSalesOrderInfo(salesOrderInfo);
        setCreateShipmentModalShow(true);
    }

    const handleShipmentDetailsModalShow = (shipment: any) => {
        setShipmentId(shipment.id);
        setDetailsShipmentModalShow(true);
    }

    const hasPermission = 1; //parseInt(GetPagePermission("/setup-company-list"));

    const baseColumns = [
        { value: 'id', title: 'ID', style: { textAlign: 'center' } },
        { value: 'idSalesOrders', title: 'Sales Order', style: { textAlign: 'center' } },
        { value: 'projectName', title: 'Project', style: { textAlign: 'center' } },
        { value: 'warehouseName', title: 'Warehouse', style: { textAlign: 'center' } },
        { value: 'companyName', title: 'Client', style: { textAlign: 'left' } },
        { value: 'leadName', title: 'Lead', style: { textAlign: 'left' } },
        { value: 'shipmentDate', title: 'Shipment Date', style: { textAlign: 'left' } },
        { value: 'chalanNo', title: 'Chalan No', style: { textAlign: 'left' } },
        { value: 'shippingAddress', title: 'Shipping Address', style: { textAlign: 'left' } },
    ];

    const shipmentAmountColumn = {
        value: 'shipmentAmount', title: 'Shipment Amount', style: { textAlign: 'center' }, hasHtmlComponent: true, htmlComponent: ((row: any) => {
            return (
                <>{numberFormat(row.shipmentAmount)}</>
            )
        })
    };

    const endColumns = [
        { value: 'remarks', title: 'Remarks', style: { textAlign: 'left' } },
        { value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'center' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return <ShipmentRowActions row={row} onDetails={handleShipmentDetailsModalShow} />
            })
        }
    ];

    // Conditionally include Shipment Amount column based on user role
    const columns = currentUser?.id_roles === 13 || currentUser?.id_roles === 15
        ? [...baseColumns, ...endColumns] 
        : [...baseColumns, shipmentAmountColumn, ...endColumns];

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        idSalesOrders: {
            filterType: 'like',
            filterValue: '',
        },
        projectName: {
            filterType: 'like',
            filterValue: '',
        },
        warehouseName: {
            filterType: 'like',
            filterValue: '',
        },
        companyName: {
            filterType: 'like',
            filterValue: '',
        },
        leadName: {
            filterType: 'like',
            filterValue: '',
        },
        shipmentDate: {
            filterType: 'like',
            filterValue: '',
        },
        chalanNo: {
            filterType: 'like',
            filterValue: '',
        },
        shippingAddress: {
            filterType: 'like',
            filterValue: '',
        },
        shipmentAmount: {
            filterType: 'like',
            filterValue: '',
        },
        remarks: {
            filterType: 'like',
            filterValue: '',
        },
        createdBy: {
            filterType: 'like',
            filterValue: '',
        },
    }

    const url = process.env.REACT_APP_API_URL + 'shipment/dt'

    const numberFormat = (value: number) => {
        return parseFloat(value.toString()).toLocaleString('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    return (
        <>
            {hasPermission === 1 &&
                <>
                    <div className='card card-custom'>
                        <div className='card-header'>
                            <div className="card-title">
                                <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                                <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                                    Shipments
                                </span>
                            </div>
                            <div className="card-toolbar">
                                <div className='d-flex justify-content-end'>
                                    <Select
                                        // defaultValue={selectProjectOptions}
                                        onChange={handleProjectChange}
                                        options={selectProjectOptions}
                                        placeholder={project.label}
                                    />
                                    &nbsp;
                                    <button onClick={() => handleShipmentModalShow(null)} className="btn btn-sm btn-primary"><i className="fa fa-plus"></i>Create New Shipment</button>
                                </div>
                            </div>
                        </div>

                        <div className='card-body'>
                            <DataTable url={url} columns={columns} filters={filters} newData={newData} additionalPostData={additionalPostData} />
                        </div>
                    </div >

                    <ShipmentCreate show={createShipmentModalShow} handleClose={handleCreateShipmentModalClose} salesOrderInfo={salesOrderInfo} id={Date.now()} />
                    {shipmentId !== '' &&
                        <ShipmentDetails show={detailsShipmentModalShow} handleClose={handleDetailsShipmentModalClose} shipmentId={shipmentId} />
                    }

                </>
            }


            {/* {hasPermission === 0 &&
                <Error />
            }
            {hasPermission === 0 &&
                <div className='card card-custom' style={{ padding: "15px" }} >
                    <SkeletonTheme>
                        <p>
                            <Skeleton
                                containerClassName="avatar-skeleton"
                                count={40} ></Skeleton>
                        </p>
                    </SkeletonTheme>
                </div>
            } */}

        </>
    )
}

export default Shipment
